<template>
  <a-card size="small" type="inner" title="Top Client Transactions">
    <a-skeleton :loading="loading" active>
      <client-bar-chart :chart-data="chartData" :options="options" />
    </a-skeleton>
  </a-card>
</template>

<script>
import ClientBarChart from "./client-bar-chart";
export default {
  components: {ClientBarChart},
  props: {
    product: {
      type: String,
      required: true
    }
  },
  name: "client-chart-container",
  data () {
    return {
      loading: false,
      items: []
    }
  },
  mounted() {
    this.getItems()
  },
  methods: {
    getItems() {
      this.loading = true
      this.$http.get(this.routeUri('hyperion.product.client.summary', {
        product_hash: this.product
      })).then(res => (this.items = res.data))
        .catch(err => this.handleXhrError(err))
        .finally(() => this.loading = false)
    },
  },
  computed: {
    chartData() {
      const labels = this.items.map(item => item.client_name)

      const valuation = {
        label: 'Transactions Value',
        data: this.items.map(item => item.price),
        maxBarThickness: 75,
      }

      return {
        labels: labels,
        datasets: [valuation]
      }
    },
    options() {
      const currency = (value) => this.currency(value)
      return {
        plugins: {
          colorschemes: {
            scheme: 'office.Aspect6'
          }
        },
        scales: {
          xAxes: [{
            gridLines: {
              offsetGridLines: true
            },
            ticks: {
              stepSize: 1000000000,
              callback: function(value, index, values) {
                return currency(value);
              }
            }
          }]
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label || '';

              if (label) {
                label += ': ';
              }

              return label + currency(tooltipItem.xLabel)
            }
          }
        }
      }
    }
  }
}
</script>
